import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/country/importer/countryImporterActions'

export default importerReducers(actions)
